import DtcIcon from "./DtcIcon"

export default  DtcIcon;
